<template>
	<hr class="lumi-divider">
</template>

<style lang="less" scoped>
	@import "~theme";
	.lumi-divider {
		border: none;
		margin: 30px 0;
		height: 1px;
		background: @black;
		opacity: 0.5;
		width: 80%;
	}
</style>

<script>
	export default {};
</script>



// WEBPACK FOOTER //
// LumiDivider.vue?dae4c254